import { Upload } from 'antd'
import type { UploadFile } from 'antd/es/upload/interface'
import { InboxOutlined } from '@ant-design/icons'

const { Dragger } = Upload

const WP_ACCEPT = '.xlsx,.pdf,.docx,.csv'

type WorkpapersPanelProps = {
  fileList: UploadFile[]
  onFileListChange: (fileList: UploadFile[]) => void
}

export function WorkpapersPanel({ fileList, onFileListChange }: WorkpapersPanelProps) {
  return (
    <div className="flex min-h-0 min-w-0 flex-col overflow-hidden rounded-xl border border-dashed border-slate-200 bg-white p-4">
      <div className="mb-4 flex min-h-[116px] shrink-0 flex-col">
        <h3 className="mb-3 text-base font-semibold text-slate-800">Workpapers</h3>
        <p className="text-sm text-slate-500">
          Upload all supporting workpapers (any format)
        </p>
      </div>
      <div className="min-h-[360px] flex-1 overflow-auto pb-14">
        <Dragger
          accept={WP_ACCEPT}
          fileList={fileList}
          multiple
          beforeUpload={() => false}
          onChange={({ fileList: next }) => onFileListChange(next)}
        >
          <p className="ant-upload-drag-icon">
            <InboxOutlined className="text-3xl text-slate-400" />
          </p>
          <p className="ant-upload-text">Drop files here or browse</p>
          <p className="ant-upload-hint text-xs text-slate-500">
            .xlsx, .pdf, .docx, .csv - multiple files
          </p>
        </Dragger>
      </div>
    </div>
  )
}
